import { createContext, useContext, useMemo } from "react";
import { getStoredUser } from "../../../utils/authRoleHelpers";

const ContractorPortalContext = createContext(null);

/**
 * Phase 7.4.0 — lightweight portal state boundary (existing React context pattern).
 * Holds contractor identity for layout; no business data loading yet.
 */
export const ContractorPortalProvider = ({ children }) => {
  const value = useMemo(() => {
    const user = getStoredUser();
    const displayName =
      user?.fullName ||
      user?.FullName ||
      user?.name ||
      user?.Name ||
      user?.userName ||
      user?.UserName ||
      "پیمانکار";

    return {
      contractorDisplayName: displayName,
      contractorUserId: user?.id ?? user?.Id ?? null,
      isPortalFoundation: true,
    };
  }, []);

  return (
    <ContractorPortalContext.Provider value={value}>
      {children}
    </ContractorPortalContext.Provider>
  );
};

export const useContractorPortal = () => {
  const ctx = useContext(ContractorPortalContext);
  if (!ctx) {
    throw new Error("useContractorPortal must be used within ContractorPortalProvider");
  }
  return ctx;
};

export default ContractorPortalContext;
